export default function formatBoolean(
  bool,
  trueText = 'Yes',
  falseText = 'No'
) {
  return bool ? trueText : falseText;
}
